export const contactEmails = {
  general: "info@irantradereach.ir",
  rfq: "sales@irantradereach.ir",
  support: "support@irantradereach.ir",
  partnership: "partners@irantradereach.ir",
} as const;

export type EnquiryKind = keyof typeof contactEmails;
export const attachmentAccept = ".pdf,.jpg,.jpeg,.png,.webp,.txt,.csv";
export const maxAttachments = 3;
export const maxFileBytes = 5 * 1024 * 1024;
export const maxTotalBytes = 10 * 1024 * 1024;
